import React from "react";
import { supportData } from "../data/supportData";

const Support = () => {
  return (
    <div className="w-full grid grid-cols-5 gap-4 items-center md:flex justify-between py-6 px-6 md:py-10 md:px-20 bg-[#219653] object-contain overflow-hidden">
      {supportData.map((items, index) => (
        <img src={items.img} alt={items.alt} key={index} />
      ))}
    </div>
  );
};

export default Support;
